<script>
import resources from './resources'
import '@desislavsd/vue-select/dist/vue-select.css'

export default {
  name: 'unit-form',
  mixins: [resources]
}
</script>

<template lang="pug">
  section.content
    .container-fluid
      .block-header
        .row
          .col-lg-5.col-md-5.col-sm-12
            h2 Locação de Unidade
            ul.breadcrumb.padding-0
              li.breadcrumb-item
                a(href='index.html')
                  i.zmdi.zmdi-home
              li.breadcrumb-item
                a(href='javascript:void(0);') Locação de Unidade
              li.breadcrumb-item.active Cadastro
          //-.col-lg-7.col-md-7.col-sm-12
            .input-group.m-b-0
              input.form-control(
                type='text',
                placeholder='Localizar Unidade',
                disabled
              )
              span.input-group-addon
                i.zmdi.zmdi-search


      .row.clearfix
        .col-lg-12
          .card
            .header
              ul.header-dropdown
                li.dropdown(:class="{'show': show}")
                  a.dropdown-toggle(@click.prevent="showActions(show)", href='javascript:void(0);')
                    i.zmdi.zmdi-more
                  ul.dropdown-menu.dropdown-menu-right(:class="{'show': show}")
                    li
                      router-link(:to="{name: 'dweller.rental.unit.index'}") Listagem
                    li
                     router-link(:to="{name: 'dweller.rental.unit.create'}") Cadastro
            .body
              h2.card-inside-title Dados da Unidade
              .row.clearfix
                .col-lg-4.col-md-4
                  .form-group
                    v-input(:status="$v.rental.tower_id.$error ? 'error' : null")
                      f-select(
                        id="unit_id",
                        name="tower",
                        track-by="id",
                        label-by="number",
                        v-model="rental.tower_id",
                        :options="dwellerTowers",
                        :searchable="true",
                        :multiple="false",
                         placeholder='Sua Torre',
                        @selected ="selectUnitsTower"
                        openDirection="bottom"
                      )

                .col-lg-4.col-md-4
                  .form-group
                    v-input(:status="$v.rental.unit_id.$error ? 'error' : null")
                      f-select(
                        id="unit_id",
                        name="Unidade",
                        track-by="id",
                        placeholder="Sua Unidade"
                        label-by="number",
                        v-model="rental.unit_id",
                        :options="dwellerRentalUnits",
                        :searchable="true",
                        :multiple="false",
                        @selected="getGaragesDweller"
                        openDirection="bottom"
                      )
                .col-lg-4.col-md-4
                  .form-group
                    v-input(:status="$v.rental.garage_id.$error ? 'error' : null")
                        f-select(
                          id="garage_id",
                          placeholder="Garagem"
                          track-by="id",
                          label="Garage (Selecine uma Unidade)",
                          label-by="number",
                          v-model="rental.garage_id",
                          :options="garages",
                          :searchable="true",
                          :multiple="false",
                          openDirection="bottom"
                        )
              h2.card-inside-title Dados do Inquilino
              .row.clearfix
                .col-lg-4.col-md-4
                  .form-group
                    v-input(:status="$v.rental.guest_name.$error ? 'error' : null")
                      input.form-control(
                        type='text',
                        placeholder='Nome do Inquilino',
                        v-model="rental.guest_name"
                      )
                .col-lg-4.col-md-4
                  .form-group
                    v-input(:status="$v.rental.guest_email.$error ? 'error' : null")
                      input.form-control(
                        type='text',
                        placeholder='Email do Inquilino',
                        v-model="rental.guest_email"
                      )
                .col-lg-4.col-md-4
                  .form-group
                    v-input(:status="$v.rental.phone.$error ? 'error' : null")
                      the-mask.form-control(
                        :mask="['(##) ####-####','(##) #####-####']",
                        name='text',
                        type='text',
                        placeholder='(00) 9 0000-0000'
                        v-model="rental.phone"
                        autocomplete="off"
                      )

                .col-lg-4.col-md-12
                  .form-group
                    .checkbox
                        input(
                          type='checkbox'
                          v-model="rental.status"
                        )
                        label(for='terms', @click.prevent="tenantStatus(!(!rental.status))")
                          | Ativar Inquilino
                .col-md-12
                    button.btn.btn-raised.btn-primary.btn-round.waves-effect(
                      type='button',
                      @click.prevent="doSave()",
                    ) Salvar

</template>
<style scoped>
.color-red {
  color: #f96332;
}
</style>



// WEBPACK FOOTER //
// src/app/dweller/rental/form/form.vue